import React, { useMemo, useState } from 'react';
import { RangeCalendarSingle } from '../../equipment-consult/components/EquipmentConsultProductionPeriodPicker';
import '../../equipment-consult/components/EquipmentConsultProductionPeriodPicker.css';
import { BoardSearchPickerShell } from './boardSearchPickerShell';

function extractScheduleDate(ordem) {
  if (!ordem?.schedule) return null;
  if (typeof ordem.schedule === 'string' && /^\d{4}-\d{2}-\d{2}/.test(ordem.schedule)) {
    return ordem.schedule.split('T')[0];
  }
  try {
    const scheduleDate = new Date(ordem.schedule);
    const year = scheduleDate.getUTCFullYear();
    const month = String(scheduleDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(scheduleDate.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch {
    return null;
  }
}

function getFuturaDateRange(orders) {
  const dates = [];
  (orders || []).forEach((ordem) => {
    const dateStr = extractScheduleDate(ordem);
    if (dateStr && dateStr !== 'SEM_PREVISAO') dates.push(dateStr);
  });
  if (dates.length === 0) return { minDate: null, maxDate: null };
  dates.sort();
  return { minDate: dates[0], maxDate: dates[dates.length - 1] };
}

export function BoardSearchOsFuturaPeriodPanel({
  orders = [],
  currentFilter,
  onApply,
  onClear,
}) {
  const dateRange = useMemo(() => getFuturaDateRange(orders), [orders]);
  const [startDate, setStartDate] = useState(currentFilter?.startDate || null);
  const [endDate, setEndDate] = useState(currentFilter?.endDate || null);

  if (!dateRange.minDate || !dateRange.maxDate) {
    return (
      <BoardSearchPickerShell>
        <div className="bsf-os-futura-empty">Nenhuma OS futura com previsão para filtrar.</div>
      </BoardSearchPickerShell>
    );
  }

  const applyDisabled = !startDate || !endDate || startDate > endDate;

  return (
    <BoardSearchPickerShell
      footer={
        <div className="bsf-popover-footer bsf-os-futura-period-actions">
          <button
            type="button"
            className="user-form-link-btn user-form-footer-btn"
            onClick={() => {
              setStartDate(null);
              setEndDate(null);
              onClear?.();
            }}
          >
            Limpar
          </button>
          <button
            type="button"
            className="user-form-profile-save-btn user-form-footer-btn"
            disabled={applyDisabled}
            onClick={() => {
              if (applyDisabled) return;
              onApply?.(startDate, endDate);
            }}
          >
            Aplicar
          </button>
        </div>
      }
    >
      <div className="bsf-os-futura-period">
        <div className="ec-period-picker-body bsf-os-futura-period-body">
          <RangeCalendarSingle
            minDate={dateRange.minDate}
            maxDate={dateRange.maxDate}
            startDate={startDate}
            endDate={endDate}
            onDateSelect={(start, end) => {
              setStartDate(start);
              setEndDate(end);
            }}
          />
        </div>
      </div>
    </BoardSearchPickerShell>
  );
}
